export const CONTACT = {
  phoneDisplay: '+237 699 30 29 39',
  phoneE164: '+237699302939',
  whatsappNumber: '237699302939',
  email: 'contact@dowhilefood.com',
  instagram: 'https://instagram.com/dowhile.food',
};
